module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./index.js"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?lazy!./~/highlight.js/lib/index.js
// module id = 98128100
// module chunks = 28 36